// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  clerkUserId: __t.string().name("clerk_user_id"),
  partyId: __t.string().name("party_id"),
  accountId: __t.string().name("account_id"),
  linkId: __t.string().name("link_id"),
  createdAt: __t.timestamp().name("created_at"),
  raw: __t.string(),
});
